import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=45438c9c"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"
import style0 from "./subscription.vue?vue&type=style&index=0&id=45438c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports